/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuthChangePasswordRequestBodyAllOf } from './AuthChangePasswordRequestBodyAllOf';
import {
    AuthChangePasswordRequestBodyAllOfFromJSON,
    AuthChangePasswordRequestBodyAllOfFromJSONTyped,
    AuthChangePasswordRequestBodyAllOfToJSON,
} from './AuthChangePasswordRequestBodyAllOf';

/**
 * 
 * @export
 * @interface AuthChangePasswordRequestBody
 */
export interface AuthChangePasswordRequestBody {
    /**
     * 
     * @type {string}
     * @memberof AuthChangePasswordRequestBody
     */
    oldPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof AuthChangePasswordRequestBody
     */
    newPassword?: string;
}

/**
 * Check if a given object implements the AuthChangePasswordRequestBody interface.
 */
export function instanceOfAuthChangePasswordRequestBody(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AuthChangePasswordRequestBodyFromJSON(json: any): AuthChangePasswordRequestBody {
    return AuthChangePasswordRequestBodyFromJSONTyped(json, false);
}

export function AuthChangePasswordRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthChangePasswordRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'oldPassword': !exists(json, 'oldPassword') ? undefined : json['oldPassword'],
        'newPassword': !exists(json, 'newPassword') ? undefined : json['newPassword'],
    };
}

export function AuthChangePasswordRequestBodyToJSON(value?: AuthChangePasswordRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'oldPassword': value.oldPassword,
        'newPassword': value.newPassword,
    };
}

